export default "__VITE_ASSET__BBvjqI8N__"